/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IndustryEnum } from './IndustryEnum';
import { IndustryEnumFromJSON, IndustryEnumFromJSONTyped, IndustryEnumToJSON } from './IndustryEnum';

/**
 *
 * @export
 * @interface Settingserializer
 */
export interface Settingserializer {
  /**
   *
   * @type {number}
   * @memberof Settingserializer
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  performance: string;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  robustness: string;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  fairness: string;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  explainability: string;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  overall: string;
  /**
   *
   * @type {string}
   * @memberof Settingserializer
   */
  riskReward: string;
  /**
   *
   * @type {IndustryEnum}
   * @memberof Settingserializer
   */
  industry?: IndustryEnum;
  /**
   *
   * @type {number}
   * @memberof Settingserializer
   */
  key?: number;
}

/**
 * Check if a given object implements the Settingserializer interface.
 */
export function instanceOfSettingserializer(value: object): value is Settingserializer {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('performance' in value) || value['performance'] === undefined) return false;
  if (!('robustness' in value) || value['robustness'] === undefined) return false;
  if (!('fairness' in value) || value['fairness'] === undefined) return false;
  if (!('explainability' in value) || value['explainability'] === undefined) return false;
  if (!('overall' in value) || value['overall'] === undefined) return false;
  if (!('riskReward' in value) || value['riskReward'] === undefined) return false;
  return true;
}

export function SettingserializerFromJSON(json: any): Settingserializer {
  return SettingserializerFromJSONTyped(json, false);
}

export function SettingserializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Settingserializer {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    performance: json['performance'],
    robustness: json['robustness'],
    fairness: json['fairness'],
    explainability: json['explainability'],
    overall: json['overall'],
    riskReward: json['risk_reward'],
    industry: json['industry'] == null ? undefined : IndustryEnumFromJSON(json['industry']),
    key: json['key'] == null ? undefined : json['key'],
  };
}

export function SettingserializerToJSON(value?: Omit<Settingserializer, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    performance: value['performance'],
    robustness: value['robustness'],
    fairness: value['fairness'],
    explainability: value['explainability'],
    overall: value['overall'],
    risk_reward: value['riskReward'],
    industry: IndustryEnumToJSON(value['industry']),
    key: value['key'],
  };
}
